import { ILink } from '../interfaces/ILink';
import {
  HOVER_FACEBOOK_LINK,
  HOVER_LINKEDIN_LINK,
  HOVER_TWITTER_LINK,
  HOVER_YOUTUBE_LINK,
} from './links';
import { ILinksGroup } from '../interfaces/ILinksGroup';

export const BOTTOM_ITEMS: Array<ILink> = [
  {
    to: `/privacy/`,
    label: 'Privacy',
  },
  {
    to: '',
    label: 'Cookies Settings',
  },
  {
    to: `/terms-of-use/`,
    label: 'Terms of use',
  },
  {
    to: HOVER_TWITTER_LINK,
    label: 'Twitter',
  },
  {
    to: HOVER_FACEBOOK_LINK,
    label: 'Facebook',
  },
  {
    to: HOVER_LINKEDIN_LINK,
    label: 'Linkedin',
  },
  {
    to: HOVER_YOUTUBE_LINK,
    label: 'Youtube',
  },
];

export const LINK_DESKTOP: ILinksGroup = [
  {
    label: 'Solutions',
    links: [
      // {
      //   label: 'Direct Ordering',
      //   to: `/direct-ordering/`,
      // },
      { label: 'New Construction', to: `/new-construction-solution/` },
      {
        label: 'Design Images',
        to: `/design-images/`,
      },
      {
        label: 'Interiors',
        to: `/interiors/`,
      },
    ],
  },
  {
    label: 'Blog',
    links: [
      {
        label: 'All articles',
        to: `/blog/`,
      },
      {
        label: 'For contractors',
        to: `/blog/exterior-contractors/`,
      },
      {
        label: 'For insurance pros',
        to: `/blog/insurance/`,
      },
      {
        label: 'For homeowners',
        to: `/blog/homeowners/`,
      },
    ],
  },
  {
    label: 'FOR HOMEOWNERS',
    links: [
      {
        label: 'How it works',
        to: `/how-it-works/`,
      },
      {
        label: 'Invited by a contractor',
        to: `/invited-by-contractor/`,
      },
      {
        label: 'Invited by an insurer',
        to: `/invited-by-insurance/`,
      },
      {
        label: 'Start Designing Now',
        to: '/homeowner-designs/',
      },
    ],
  },
  {
    label: 'RESOURCES',
    links: [
      {
        label: 'Help Center',
        to: 'https://help.hover.to/en/',
      },
      {
        label: 'Vinyl Siding Estimator',
        to: '/vinyl-siding-estimator/',
      },
      {
        label: 'How To Measure a Roof',
        to: '/how-to-measure-a-roof/',
      },
      {
        label: 'Exterior House Design',
        to: '/exterior-house-design/',
      },
    ],
  },
  {
    label: 'FOR PROFESSIONALS',
    links: [
      {
        label: 'Exterior contractors',
        to: `/exterior-contractors/`,
      },
      {
        label: 'Insurance',
        to: `/insurance/`,
      },
      {
        label: 'Restoration',
        to: `/restoration/`,
      },
      {
        label: 'Architects',
        to: `/architects/`,
      },
    ],
  },
  {
    label: 'COMPANY',
    links: [
      {
        label: 'About us',
        to: `/about/`,
      },
      {
        label: 'Press',
        to: `/press/`,
      },
      {
        label: 'Careers',
        to: `/careers/`,
      },
      {
        label: 'Contact us',
        to: `/contact/`,
      },
      {
        label: 'Talk to sales',
        to: `/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website_Footer/`,
      },
    ],
  },
];

export const LINK_MOBILE: ILinksGroup = [
  {
    label: 'Solutions',
    links: [
      // {
      //   label: 'Direct Ordering',
      //   to: `/direct-ordering/`,
      // },
      { label: 'New Construction', to: `/new-construction-solution/` },
      {
        label: 'HOVER Design',
        to: `/design-images/`,
      },
      {
        label: 'Interiors',
        to: `/interiors/`,
      },
    ],
  },
  {
    label: 'FOR HOMEOWNERS',
    links: [
      {
        label: 'How it works',
        to: `/how-it-works/`,
      },
      {
        label: 'Invited by a contractor',
        to: `/invited-by-contractor/`,
      },
      {
        label: 'Invited by an insurer',
        to: `/invited-by-insurance/`,
      },
    ],
  },
  {
    label: 'FOR PROFESSIONALS',
    links: [
      {
        label: 'Exterior contractors',
        to: `/exterior-contractors/`,
      },
      {
        label: 'Insurance',
        to: `/insurance/`,
      },
      {
        label: 'Restoration',
        to: `/restoration/`,
      },
      {
        label: 'Architects',
        to: `/architects/`,
      },
    ],
  },
  {
    label: 'Blog',
    links: [
      {
        label: 'All articles',
        to: `/blog/`,
      },
      {
        label: 'For contractors',
        to: `/blog/exterior-contractors/`,
      },
      {
        label: 'For insurance pros',
        to: `/blog/insurance/`,
      },
      {
        label: 'For homeowners',
        to: `/blog/homeowners/`,
      },
    ],
  },
  {
    label: 'RESOURCES',
    links: [
      {
        label: 'Help Center',
        to: 'https://help.hover.to/en/',
      },
      {
        label: 'Vinyl Siding Estimator',
        to: '/vinyl-siding-estimator/',
      },
      {
        label: 'How To Measure a Roof',
        to: '/how-to-measure-a-roof/',
      },
      {
        label: 'Exterior House Design',
        to: '/exterior-house-design/',
      },
    ],
  },
  {
    label: 'COMPANY',
    links: [
      {
        label: 'About us',
        to: `/about/`,
      },
      {
        label: 'Press',
        to: `/press/`,
      },
      {
        label: 'Careers',
        to: `/careers/`,
      },
      {
        label: 'Contact us',
        to: `/contact/`,
      },
      {
        label: 'Talk to sales',
        to: `/lp/hover-sdr/`,
      },
    ],
  },
];
